import { z } from 'zod';

import { BASE_SCHEMAS } from './base';

export const itemSchema = z.object({
  name: BASE_SCHEMAS.requiredString({
    fieldName: 'Name',
    minLength: 1,
  }),
  description: z.string().optional(),
  price: z.number().min(0, 'Price must be positive'),
  packagingPrice: z
    .number()
    .min(0, 'Packaging price must be positive')
    .optional(),
  categoryId: z.string().optional(),
  dietary: z.enum(['veg', 'non-veg', 'egg']).optional(),
});

export type ItemFormData = z.infer<typeof itemSchema>;

export const itemDefaultValues: ItemFormData = {
  name: '',
  description: '',
  price: 0,
  packagingPrice: 0,
  categoryId: '',
  dietary: 'veg',
};
